import {AnyEvent, JOB_VARIATION_ITEM_UPDATED, JobVariationItemUpdatedEvent} from '../type';

export default function jobVariationItemUpdated(payload: JobVariationItemUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_VARIATION_ITEM_UPDATED,
    payload,
  }
}